// extracted by mini-css-extract-plugin
module.exports = {"click":"DogSearchByTemperament_click__1VPVD"};